export default __webpack_public_path__ + "static/base-lite-1-40f2b4c6b8b567fe927f7f0dda3aacf9.jpg";